import './breadProgressMega.scss'
export default function breadProgressMega(
  $location,
  $stateParams,
  $state,
  $rootScope,
  $timeout,
  MegaBundlesService,
  BundleService,
) {
  'ngInject'
  var directive = {
    restrict: 'E',
    scope: {
      entry: '=',
      parentId: '@',
    },
    templateUrl: 'app/components/breadProgressMega/breadProgressMega.html',
    link: breadProgressMegaLink,
  }

  return directive

  function breadProgressMegaLink($scope, $element, $attr) {
    $scope.itemOdds = [
      {
        step: '1',
        name: 'Details ',
        className: 'todo',
        disable: false,
      },
      {
        step: '2',
        name: 'Collectibles',
        className: 'todo',
        disable: false,
      },
      {
        step: '3',
        name: 'Collectibles from Other Sets',
        className: 'todo',
        disable: false,
      },
      {
        step: '4',
        name: 'Collectibles from Other Channels',
        className: 'todo',
        disable: false,
      },
      {
        step: '5',
        name: 'Odds',
        className: 'todo',
        disable: false,
      },
    ]

    //odds
    if ($attr.entry === 'Details') {
      $scope.itemOdds[0].className = 'active'
    } else if ($attr.entry === 'Odd2') {
      $scope.itemOdds[0].className = 'todo'
      $scope.itemOdds[0].step = ''
      $scope.itemOdds[1].className = 'active'
    } else if ($attr.entry === 'Odd3') {
      $scope.itemOdds[0].className = 'todo'
      $scope.itemOdds[0].step = ''
      $scope.itemOdds[1].className = 'todo'
      $scope.itemOdds[1].step = ''
      $scope.itemOdds[2].className = 'active'
    } else if ($attr.entry === 'Odd4') {
      $scope.itemOdds[0].className = 'todo'
      $scope.itemOdds[0].step = ''
      $scope.itemOdds[1].className = 'todo'
      $scope.itemOdds[1].step = ''
      $scope.itemOdds[2].className = 'todo'
      $scope.itemOdds[2].step = ''
      $scope.itemOdds[3].className = 'active'
    } else if ($attr.entry === 'Odd5') {
      $scope.itemOdds[0].className = 'todo'
      $scope.itemOdds[0].step = ''
      $scope.itemOdds[1].className = 'todo'
      $scope.itemOdds[1].step = ''
      $scope.itemOdds[2].className = 'todo'
      $scope.itemOdds[2].step = ''
      $scope.itemOdds[3].className = 'todo'
      $scope.itemOdds[3].step = ''
      $scope.itemOdds[4].className = 'active'
    }

    $scope.link = function(item) {
      var path = $location.$$path,
        id
      if (path.indexOf('channels') === -1) {
        id = $stateParams.parentId
      } else {
        id = $stateParams.id
      }

      switch (item.name) {
        case 'Details ':
          $state.go('admin.megabundles.step1', {
            parentId: $attr.parentId,
            id: $stateParams.id,
            publisherId: $stateParams.publisherId,
            productType: $stateParams.productType,
            channelId: $stateParams.channelId,
            setId: $stateParams.setId,
            new: false,
          })
          break
        case 'Collectibles':
          $state.go('admin.megabundles.step2', {
            parentId: $attr.parentId,
            id: $stateParams.id,
            publisherId: $stateParams.publisherId,
            productType: $stateParams.productType,
            channelId: $stateParams.channelId,
            setId: $stateParams.setId,
          })
          break
        case 'Collectibles from Other Sets':
          $state.go('admin.megabundles.step3', {
            parentId: $attr.parentId,
            id: $stateParams.id,
            publisherId: $stateParams.publisherId,
            productType: $stateParams.productType,
            channelId: $stateParams.channelId,
            setId: $stateParams.setId,
          })
          break
        case 'Collectibles from Other Channels':
          $state.go('admin.megabundles.step4', {
            parentId: $attr.parentId,
            id: $stateParams.id,
            publisherId: $stateParams.publisherId,
            productType: $stateParams.productType,
            channelId: $stateParams.channelId,
            setId: $stateParams.setId,
          })
          break
        case 'Odds':
          $state.go('admin.megabundles.step5', {
            parentId: $attr.parentId,
            id: $stateParams.id,
            publisherId: $stateParams.publisherId,
            productType: $stateParams.productType,
            channelId: $stateParams.channelId,
            setId: $stateParams.setId,
          })
          break
      }
    }

    $scope.publish = function() {
      swal(
        {
          title: 'Are you sure',
          text: 'Bundle will be published at the time indicated in the "published at" field',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          closeOnConfirm: true,
          type: 'warning',
          animation: 'slide-from-top',
          allowEscapeKey: false,
          allowOutsideClick: false,
        },
        function(isConfirm) {
          if (!isConfirm) {
            return
          } else {
            BundleService.publish($stateParams.id).then(
              function() {
                toastr.success('Published!')
              },
              function(err) {
                var e = err.error.message.split(';')
                var html = ''
                for (var i = 0; i < e.length; i++) {
                  html += '<p style="color:red; font-size:14px; font-weigth:100;">' + e[i] + '</p>'
                }
                $timeout(function() {
                  swal({
                    title: 'Pack Incomplete',
                    text: html,
                    html: true,
                  })
                }, 500)
              },
            )
          }
        },
      )
    }

    $scope.reset = function() {
      swal(
        {
          title: 'Are you sure',
          text: 'You will reset all odds',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          closeOnConfirm: true,
          type: 'warning',
          animation: 'slide-from-top',
          allowEscapeKey: false,
          allowOutsideClick: false,
        },
        function(isConfirm) {
          if (!isConfirm) {
            return
          } else {
            MegaBundlesService.addOdds(
              parseInt($stateParams.id),
              2,
              $stateParams.publisherId,
              $stateParams.productType,
              '',
            ).then(
              function() {
                toastr.success('Reseted!')
                $state.reload()
              },
              function(err) {
                var e = err.error.message.split(';')
                var html = ''
                for (var i = 0; i < e.length; i++) {
                  html += '<p style="color:red; font-size:14px; font-weigth:100;">' + e[i] + '</p>'
                }
                $timeout(function() {
                  swal({
                    title: 'Error',
                    text: html,
                    html: true,
                  })
                }, 500)
              },
            )
          }
        },
      )
    }

    $scope.soldout = function() {
      BundleService.update($stateParams.parentId, $stateParams.id, {
        st: 2,
      }).then(function() {
        swal('Sold Out', '', 'success')
      })
    }
  }
}
